import React from 'react';
import PropTypes from 'prop-types';

import { StyledList, ListElement } from './Styles';

const propTypes = {
  filterList: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSelect: PropTypes.func.isRequired,
  openPopOver: PropTypes.func.isRequired
};

const ListFilter = ({ filterList, handleSelect, openPopOver }) => {
  const applySelection = selectedIndex => {
    const updatedlist = filterList.map((elem, index) => {
      if (selectedIndex === index) {
        return { ...elem, isSelected: true };
      }
      return { ...elem, isSelected: false };
    });

    handleSelect(updatedlist);
    openPopOver(false);
  };

  return (
    <StyledList data-testid="list-filter">
      {filterList &&
        filterList.map((elem, index) => {
          return (
            <ListElement
              key={elem.displayName}
              onClick={() => applySelection(index)}
              isSelected={elem.isSelected}
              data-testid={elem.value}
            >
              {elem.displayName}
            </ListElement>
          );
        })}
    </StyledList>
  );
};

ListFilter.propTypes = propTypes;

export default ListFilter;
